<template>
  <div class="accordion-fields">
    <slot />
  </div>
</template>

<script setup>
import { provide, ref, watch } from "vue";
import { formFragmentValues, setFormFragmentValues } from "@/utils";

const localeValues = formFragmentValues();
const expandedIndex = ref(localeValues.selectNumber !== null ? localeValues.selectNumber : null );

function setExapandedIndex(index) {
  expandedIndex.value = expandedIndex.value === index ? null : index;
}

provide("expandedIndex", { expandedIndex, setExapandedIndex });

watch(expandedIndex, () => {
  setFormFragmentValues({
      selectNumber: expandedIndex.value
  })
});
</script>
